export default "__VITE_ASSET__4r0o1tU$__"